let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gCbFf")).then(() => parcelRequire('895TH'));